import AddTeamSchedule from '@/views/team/tabs/schedule/Edit.vue';

export const addTeamScheduleRoute = {
  path: 'add',
  name: 'addTeamSchedule',
  component: AddTeamSchedule,
  meta: {
    breadcrumb: {
      title: 'breadcrumbs.schedules.add'
    }
  }
};
